import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import AppStore from './app/index'
import UserStore from './user/index'
import ReportsStore from './reports/index'
import SuppliersStore from './suppliers/index'
import PortalsStore from './portals/index'
import TargetsStore from './targets/index'
import ServicesStore from './services/index'
import ProductsStore from './products/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: AppStore,
    user: UserStore,
    reports: ReportsStore,
    suppliers: SuppliersStore,
    portals: PortalsStore,
    targets: TargetsStore,
    services: ServicesStore,
    products: ProductsStore
  },
  plugins: [createPersistedState({
    paths: [
      'user.token'
    ]
  })]
})
